import { useQuery } from 'react-query'
import { api } from '../../../api'

export const fetchMeetingsByAttendeEmail = async (email: string) => {
  const response = await api.get(`/meetings/${email}`)
  return response.data
}

export const useMeetingsByAttendeeEmail = (email: string) => {
  return useQuery(['meetings'], () => fetchMeetingsByAttendeEmail(email))
}

export const fetchLastMeetingByTaskId = async (id: number) => {
  const response = await api.get(`/meetings/last-by-task/${id}`)
  return response.data
}
